

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { BrowserMultiFormatReader, Result } from '@zxing/library';

@Component({
  components: {}
})
export default class BarcodeScanner extends Vue {
  private codeReader = new BrowserMultiFormatReader();
  private videoWidth = '100%';
  private videoHeight = '400';
  private videoVisible = false;

  @Prop({ required: false, type: String })
  private title?: string;

  mounted() {
    // empty
  }

  async startScan() {
    if (
      window.matchMedia('(max-width: 480px)').matches ||
      window.matchMedia('(max-height: 480px)').matches
    ) {
      await this.lockScreenPortrait();
      const inLandscape = window.matchMedia('(orientation: landscape)');
      if (inLandscape.matches) return;
    }
    this.startVideoHandler();
  }

  startVideoHandler() {
    this.$emit('on-scanned', '');
    this.videoVisible = true;
    this.codeReader
      .decodeOnceFromVideoDevice(undefined, 'video')
      .then(this.pushBarcode)
      .catch(() => {
        /* ignore-exception-when-video-closed-without-scanning */
      });
  }

  async lockScreenPortrait(): Promise<boolean> {
    try {
      await this.fullScreenCheck();
    } catch (err) {
      console.error(err);
    }
    try {
      await screen.orientation.lock('portrait');
      return true;
    } catch (err) {
      console.error(err);
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
      this.lockScreenFail();
      return false;
    }
  }

  fullScreenCheck() {
    if (document.fullscreenElement) return;
    return document.documentElement.requestFullscreen();
  }

  lockScreenFail() {
    const inPortrait = window.matchMedia('(orientation: portrait)');
    if (inPortrait.matches) {
      alert(
        'Keep device in portrait while using scanner or turn off screen auto rotation in device settings if necessary.'
      );
    } else {
      alert(
        'Start scanner with device in portrait. Turn off screen auto rotation in device settings if necessary.'
      );
    }
  }

  stopVideoHandler() {
    this.codeReader.reset();
    this.videoVisible = false;
    if (!document.fullscreenElement) return;
    screen.orientation.unlock();
    document.exitFullscreen();
  }

  pushBarcode(barcode: Result) {
    this.$emit('on-scanned', barcode.getText());
    this.stopVideoHandler();
  }
}
